(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tp-regalos"] && !Shopify.designMode) return;
  try {
    /*
   * Línea de "Llevas N charms": se vuelve a contar con /cart.js cada vez que
   * Horizon (o "Completa tu collar") agrega, cambia o quita algo del carrito.
   */
  (() => {
    if (window.tpRegalosListo) return;
    window.tpRegalosListo = true;

    const texto = (n, libres) => {
      if (n === 0) return '<strong>Tus regalos</strong>';
      if (n < 5) {
        const faltan = 5 - n;
        const llevas = `Llevas ${n} ${n === 1 ? 'charm' : 'charms'}`;
        return faltan === 1
          ? `${llevas} · te falta <strong>1</strong> para tu collar gratis`
          : `${llevas} · te faltan <strong>${faltan}</strong> para tu collar gratis`;
      }
      const piezas = Math.floor(n / 5);
      if (n < 10) {
        return libres >= piezas
          ? `<strong>Tu pieza gratis ya está en tu carrito</strong> · con ${10 - n} más, otra y envío gratis`
          : '<strong>Ya tienes tu collar o pulsera gratis:</strong> elígelo en tu carrito';
      }
      return libres >= piezas
        ? `<strong>Tus ${piezas} piezas gratis ya están en tu carrito</strong> y tu envío es gratis`
        : `<strong>Ya tienes ${piezas} piezas gratis</strong> y envío gratis: elígelas en tu carrito`;
    };

    const pintar = (n, libres = 0) => {
      let llenos = n % 5;
      if ((n > 0 && llenos === 0) || n >= 10) llenos = 5;
      document.querySelectorAll('[data-tp-regalos]').forEach((caja) => {
        const estado = caja.querySelector('[data-tp-regalos-estado]');
        if (estado) estado.innerHTML = texto(n, libres);
        caja.querySelectorAll('.tp-regalos__punto').forEach((punto, i) => {
          punto.classList.toggle('is-lleno', i < llenos);
        });
      });
    };

    const contar = (items = []) =>
      items.reduce((suma, item) => suma + (item.product_type === 'Charm' ? item.quantity : 0), 0);

    // Piezas gratis ya en el carrito: collar o pulsera que quedó en $0 por el descuento
    const libresEn = (items = []) =>
      items.reduce(
        (suma, item) =>
          suma +
          ((item.product_type === 'Collar' || item.product_type === 'Pulsera') && item.final_line_price === 0
            ? item.quantity
            : 0),
        0
      );

    const refrescar = () => {
      if (!document.querySelector('[data-tp-regalos]')) return;
      const ruta = (window.Theme?.routes?.cart_url || '/cart') + '.js';
      fetch(ruta, { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
        .then((r) => r.json())
        .then((carrito) => pintar(contar(carrito.items), libresEn(carrito.items)))
        .catch(() => {});
    };

    document.addEventListener('shopify:cart:lines-update', (evento) => {
      Promise.resolve(evento.promise).then(refrescar, refrescar);
    });
    window.addEventListener('pageshow', (evento) => {
      if (evento.persisted) refrescar();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
